export class PricingModal {
  private overlay: HTMLElement;
  private modal: HTMLElement;

  constructor(container: HTMLElement) {
    this.overlay = document.createElement('div');
    this.overlay.className = 'auth-overlay hidden';

    this.modal = document.createElement('div');
    this.modal.className = 'pricing-modal';
    this.modal.innerHTML = `
      <div class="auth-modal-header">
        <h3>Planos PREVDRIVE</h3>
        <button id="pricingClose" class="auth-modal-close">&times;</button>
      </div>
      <div class="pricing-grid">
        <div class="pricing-card pricing-free">
          <div class="pricing-name">Free</div>
          <div class="pricing-price">Grátis</div>
          <ul class="pricing-features">
            <li>1 usuário</li>
            <li>Até 5 catálogos</li>
            <li>Armazenamento local</li>
            <li>Diagnóstico preditivo</li>
          </ul>
        </div>
        <div class="pricing-card pricing-basic">
          <div class="pricing-name">Basic</div>
          <div class="pricing-price">R$ 29<small>/mês</small></div>
          <ul class="pricing-features">
            <li>1 usuário</li>
            <li>Catálogos ilimitados</li>
            <li>Armazenamento na nuvem</li>
            <li>30 dias de telemetria</li>
          </ul>
        </div>
        <div class="pricing-card pricing-pro">
          <div class="pricing-name">Pro</div>
          <div class="pricing-price">R$ 79<small>/mês</small></div>
          <ul class="pricing-features">
            <li>Até 5 usuários</li>
            <li>Catálogos ilimitados</li>
            <li>Telemetria em tempo real</li>
            <li>90 dias de histórico</li>
          </ul>
        </div>
        <div class="pricing-card pricing-enterprise">
          <div class="pricing-name">Enterprise</div>
          <div class="pricing-price">Sob consulta</div>
          <ul class="pricing-features">
            <li>Usuários ilimitados</li>
            <li>Self-hosted disponível</li>
            <li>SLA garantido</li>
            <li>Suporte prioritário</li>
          </ul>
        </div>
      </div>
    `;

    container.appendChild(this.overlay);
    container.appendChild(this.modal);

    const closeBtn = this.modal.querySelector('#pricingClose')!;
    this.overlay.addEventListener('click', () => this.close());
    closeBtn.addEventListener('click', () => this.close());
  }

  destroy(): void {
    this.overlay.remove();
    this.modal.remove();
  }

  open(): void {
    this.overlay.classList.remove('hidden');
    this.modal.classList.add('open');
  }

  close(): void {
    this.overlay.classList.add('hidden');
    this.modal.classList.remove('open');
  }
}
